<template>
  <div class="post-likeheart grid">
    <p
      class="text-xs font-bold mr-2 cursor-default hover:underline"
      :class="{ 'textblue font-black': commentData.likes.length }"
      @mouseenter="likeemoji = true"
      @click="commentData.likes.length ? handleLike('') : ''"
    >
      Like ({{ commentData.totalLikes }})
    </p>

    <!-- <div class="flex items-center cursor-pointer " @click="handleLike('')" v-if="likes">
      
    </div> -->
    <div class="cust-likesbox" v-if="likeemoji && !commentData.likes.length">
      <div
        class="cust-hoverLike"
        @mouseenter="likeemoji = true"
        @mouseleave="likeemoji = false"
      >
        <a class="Like__link js-hover"></a>
        <div class="cust-likesemojiparent">
          <div
            v-for="(reaction, index) in reactions"
            :key="'-reaction-' + index"
            class="cust-likesemoji"
            :class="reaction.emoji"
            @click="handleLike(reaction.type)"
          >
            <!-- <div class="cust-likiesicon" :class="reaction.icon"></div> -->
            <div class="">
              <img :src="reaction.img" class="p-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    commentID: {
      type: String,
      required: true,
    },
    liketype: {
      type: String,
      required: true,
    },
    commentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      likeemoji: false,
      reactions: [
        {
          type: "like",
          emoji: "Emoji--like",
          icon: "icon--like",
          img: require("../img/thumb.jpg"),
        },
        {
          type: "celebrate",
          emoji: "Emoji--sad",
          icon: "icon--sad",
          img: require("../img/clapping.jpg"),
        },
        {
          type: "support",
          emoji: "Emoji--angry",
          icon: "icon--angry",
          img: require("../img/support.jpg"),
        },
        {
          type: "love",
          emoji: "Emoji--love",
          icon: "icon--heart",
          img: require("../img/heart.jpg"),
        },
        {
          type: "insightful",
          emoji: "Emoji--haha",
          icon: "icon--haha",
          img: require("../img/lamp.jpg"),
        },
        {
          type: "curios",
          emoji: "Emoji--wow",
          icon: "icon--wow",
          img: require("../img/curios.jpg"),
        },
      ],
    };
  },
  computed: {
    likeTypeImage() {
      return this.reactions.find((x) => x.type === this.likeType).img;
    },
    ...mapState("channel", ["selectedChannel"]),
  },
  methods: {
    handleLike(type) {
      if (this.commentData.likes.length) {
        this.unlikeComment();
      } else {
        this.likeComment(type);
      }
    },
    async likeComment(type) {
      let loader = this.$loading();
      try {
        const payload = {
          type: type,
          liketype: this.liketype,
          commentId: this.commentID,
        };

        await this.$store.dispatch("posts/likeComment", payload);
        // this.$store.dispatch("channel/GetALLChannel");
        // console.log(this.commentID);
        await this.$store.dispatch(
          "posts/getChannelPosts",
          this.selectedChannel._id
        );
        this.$emit("like", {});
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async unlikeComment() {
      let loader = this.$loading();
      try {
        const payload = {
          commentId: this.commentID,
          liketype: this.liketype,
        };

        await this.$store.dispatch("posts/unlikeComment", payload);
        // this.$store.dispatch("channel/GetALLChannel");
        // console.log(this.commentID);
        await this.$store.dispatch(
          "posts/getChannelPosts",
          this.selectedChannel._id
        );
        this.$emit("like", {});
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    // async likeUnlikeComment(commentID, isLiked) {
    //   let loader = this.$loading();
    //   try {
    //     if (isLiked) {
    //       let unLike = {
    //         commentId: commentID,
    //       };
    //       console.log("testting likeUnlikePost");

    //       await this.$store.dispatch("posts/unlikeComment", unLike);
    //     } else {
    //       let Like = {
    //         type: "like",
    //         commentId: commentID,
    //       };
    //       console.log("testting teeest");

    //       await this.$store.dispatch("posts/likeComment", Like);
    //     }
    //     loader.close();
    //   } catch (error) {
    //     if (error) {
    //       loader.close();
    //     }
    //   }
    // },
  },
};
</script>

<style lang="scss">
@import "../scss/PostLike.scss";
</style>
